const installed = new WeakSet();

export function installFlickityFade({F, r: D, a: b}) {
  if (installed.has(F)) return;
  var h = {exports: {}},
    E = h.exports,
    u;
  function M() {
    return (
      u ||
        ((u = 1),
        (function (p) {
          (function (o, n) {
            p.exports ? (p.exports = n(D(), b())) : n(o.Flickity, o.fizzyUIUtils);
          })(E, function (n, g) {
            var f = n.Slide,
              v = f.prototype.updateTarget;
            (f.prototype.updateTarget = function () {
              if ((v.apply(this, arguments), !!this.parent.options.fade)) {
                var e = this.target - this.x,
                  s = this.cells[0].x;
                this.cells.forEach(function (i) {
                  var a = i.x - s - e;
                  i.renderPosition(a);
                });
              }
            }),
              (f.prototype.setOpacity = function (e) {
                this.cells.forEach(function (s) {
                  s.element.style.opacity = e;
                });
              });
            var t = n.prototype;
            n.createMethods.push('_createFade'),
              (t._createFade = function () {
                (this.fadeIndex = this.selectedIndex),
                  (this.prevSelectedIndex = this.selectedIndex),
                  this.on('select', this.onSelectFade),
                  this.on('dragEnd', this.onDragEndFade),
                  this.on('settle', this.onSettleFade),
                  this.on('activate', this.onActivateFade),
                  this.on('deactivate', this.onDeactivateFade);
              });
            var x = t.updateSlides;
            (t.updateSlides = function () {
              x.apply(this, arguments),
                this.options.fade &&
                  this.slides.forEach(function (e, s) {
                    var i = s == this.selectedIndex ? 1 : 0;
                    e.setOpacity(i);
                  }, this);
            }),
              (t.onSelectFade = function () {
                (this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1)),
                  (this.prevSelectedIndex = this.selectedIndex);
              }),
              (t.onSettleFade = function () {
                if ((delete this.didDragEnd, !!this.options.fade)) {
                  this.selectedSlide.setOpacity(1);
                  var e = this.slides[this.fadeIndex];
                  e && this.fadeIndex != this.selectedIndex && this.slides[this.fadeIndex].setOpacity(0);
                }
              }),
              (t.onDragEndFade = function () {
                this.didDragEnd = !0;
              }),
              (t.onActivateFade = function () {
                this.options.fade && this.element.classList.add('is-fade');
              }),
              (t.onDeactivateFade = function () {
                this.options.fade &&
                  (this.element.classList.remove('is-fade'),
                  this.slides.forEach(function (e) {
                    e.setOpacity('');
                  }));
              });
            var I = t.positionSlider;
            t.positionSlider = function () {
              if (!this.options.fade) {
                I.apply(this, arguments);
                return;
              }
              this.fadeSlides(), this.dispatchScrollEvent();
            };
            var S = t.positionSliderAtSelected;
            (t.positionSliderAtSelected = function () {
              this.options.fade && this.setTranslateX(0), S.apply(this, arguments);
            }),
              (t.fadeSlides = function () {
                if (!(this.slides.length < 2)) {
                  var e = this.getFadeIndexes(),
                    s = this.slides[e.a],
                    i = this.slides[e.b],
                    a = this.wrapDifference(s.target, i.target),
                    d = this.wrapDifference(s.target, -this.x);
                  (d = d / a), s.setOpacity(1 - d), i.setOpacity(d);
                  var r = e.a;
                  this.isDragging && (r = d > 0.5 ? e.a : e.b);
                  var l =
                    this.fadeHideIndex != null &&
                    this.fadeHideIndex != r &&
                    this.fadeHideIndex != e.a &&
                    this.fadeHideIndex != e.b;
                  l && this.slides[this.fadeHideIndex].setOpacity(0), (this.fadeHideIndex = r);
                }
              }),
              (t.getFadeIndexes = function () {
                return !this.isDragging && !this.didDragEnd
                  ? {a: this.fadeIndex, b: this.selectedIndex}
                  : this.options.wrapAround
                    ? this.getFadeDragWrapIndexes()
                    : this.getFadeDragLimitIndexes();
              }),
              (t.getFadeDragWrapIndexes = function () {
                var e = this.slides.map(function (c, m) {
                    return this.getSlideDistance(-this.x, m);
                  }, this),
                  s = e.map(function (c) {
                    return Math.abs(c);
                  }),
                  i = Math.min.apply(Math, s),
                  a = s.indexOf(i),
                  d = e[a],
                  r = this.slides.length,
                  l = d >= 0 ? 1 : -1;
                return {a, b: g.modulo(a + l, r)};
              }),
              (t.getFadeDragLimitIndexes = function () {
                for (var e = 0, s = 0; s < this.slides.length - 1; s++) {
                  var i = this.slides[s];
                  if (-this.x < i.target) break;
                  e = s;
                }
                return {a: e, b: e + 1};
              }),
              (t.wrapDifference = function (e, s) {
                var i = s - e;
                if (!this.options.wrapAround) return i;
                var a = i + this.slideableWidth,
                  d = i - this.slideableWidth;
                return Math.abs(a) < Math.abs(i) && (i = a), Math.abs(d) < Math.abs(i) && (i = d), i;
              });
            var y = t._getWrapShiftCells;
            t._getWrapShiftCells = function () {
              this.options.fade || y.apply(this, arguments);
            };
            var F = t.shiftWrapCells;
            return (
              (t.shiftWrapCells = function () {
                this.options.fade || F.apply(this, arguments);
              }),
              n
            );
          });
        })(h)),
      h.exports
    );
  }
  M();
  installed.add(F);
}
